package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 选项卡内容容器。
 *
 * 仅承载一组子元素 + 显示在 header 上的标题；本身不参与点击 / 布局以外的事件。
 * 由 [TabView] 通过 [UIElement.children] 过滤决定哪个 Tab 当前可见。
 */
class Tab private constructor() : UIElement<Tab>() {

    private var titleText: String = ""

    protected override fun self(): Tab = this

    /** 设置标题（null 视作空串），返回自身以便链式调用。 */
    fun title(t: String?): Tab {
        titleText = t ?: ""
        return this
    }

    /** 取标题；未显式设置时回退到 id，便于 DSL `tab "General" {}` 写法。 */
    fun title(): String {
        val currentId = idField
        return if (titleText.isEmpty() && currentId != null) currentId else titleText
    }

    companion object {
        /** 创建一个选项卡容器。 */
        @JvmStatic
        fun create(): Tab = Tab()
    }
}
